import Storage from "../storage";

class IdentityAndAccessController {

    /**
     * Returns the current session status.
     *
     * @returns {Boolean} Returns true if there is a session active
     */
    static get sessionStatus () {
        const submittedTime = new Date().getTime();
        const existingTime = Storage.getData("defaultExpiry") * 1000 || submittedTime;
        const expectedTimeout = submittedTime - existingTime;
        const sessionKeyActive = this.sessionKey !== null;

        return 1 <= expectedTimeout && sessionKeyActive;
    }

    /**
     * Get the token
     *
     * @returns {string|null} The session key
     */
    static get sessionKey () {
        const storageKey = Storage.getData("sessionKey") || { key: null };

        return storageKey.key;
    }

    /**
     * Set the session
     *
     * @param sessionObject {Object} Session object
     */
    static set session (sessionObject) {
        const expectedTimeout = sessionObject.expiry_time * 1000;

        const accessToken = sessionObject.token;
        const expiresInSeconds = sessionObject.expiry_time;

        /** Add any information into the HTML5 storage **/
        Storage.setSessionKey(accessToken, expiresInSeconds);
        Storage.setData("policy", sessionObject.policy, expiresInSeconds);
        Storage.setData("profile", sessionObject.profile, expiresInSeconds);
        Storage.setData("presets", sessionObject.presets, expiresInSeconds);
        Storage.setData("advisorEmailAddress", sessionObject.advisorEmailAddress, expiresInSeconds);
        Storage.setData("advisorName", sessionObject.advisorName, expiresInSeconds);
        Storage.setData("corporateLogo", sessionObject.corporateLogo, expiresInSeconds);
        Storage.setData("advisor", {
            logo: sessionObject.corporateLogo,
            email: sessionObject.advisorEmailAddress,
            name: sessionObject.advisorName,
            avatar: sessionObject.advisorAvatarUrl,
            websiteURL: sessionObject.organisationWebsiteUrl,
            address: sessionObject.organisationAddress,
            business: sessionObject.profile.organisationName
        }, expiresInSeconds)
        Storage.setData("style", sessionObject.style, expiresInSeconds);
        Storage.setData("defaultExpiry", sessionObject.expiry_time);
        Storage.setData("settings", sessionObject.settings, expiresInSeconds);
        Storage.setData("expiryTime", expectedTimeout);

        /** Store the email locally so the user can login by simply entering their password next time **/
        Storage.setData("emailAddress", sessionObject.profile.email);
    }

    /**
     * Destroy the session
     */
    static destroySession () {
        Storage.flush();
    }

    /**
     * Refire the session
     */
    static refireSession () {
        const expiresInSeconds = Storage.getData("defaultExpiry");

        if (null !== expiresInSeconds) {
            /** Time the user submitted their details. **/
            this.submittedTime = new Date().getTime();
            const expectedTimeout = this.submittedTime + (expiresInSeconds * 1000);

            Storage.setTTL("sessionKey", expiresInSeconds);
            Storage.setTTL("defaultExpiry", expiresInSeconds);
            Storage.setTTL("policy", expiresInSeconds);
            Storage.setTTL("profile", expiresInSeconds);
            Storage.setTTL("presets", expiresInSeconds);
            Storage.setTTL("advisorEmailAddress", expiresInSeconds);
            Storage.setTTL("advisorName", expiresInSeconds);
            Storage.setTTL("style", expiresInSeconds);
            Storage.setTTL("settings", expiresInSeconds);
            Storage.setTTL("corporateLogo", expiresInSeconds);
            Storage.setData("expiryTime", expectedTimeout);
        }
    }

}

export default IdentityAndAccessController;


// WEBPACK FOOTER //
// ./public/domain/controllers/identity-and-access-controller/index.js